export default __webpack_public_path__ + "static/media/dataQuality_ln.651d2c3a.svg";